( function ( $ ) {
	'use strict';

	const $html = $( 'html' );
	const $navOpenClass = 'nav-open';

	/* Open Nav on Click */
	$( '.site-header__nav-toggle' ).on( 'click', function () {
		$html.toggleClass( $navOpenClass );
		if( 'false' == $( this ).attr( 'aria-expanded' ) ) {
			$( this ).attr( 'aria-expanded', 'true' );
		} else {
			$( this ).attr( 'aria-expanded', 'false' );
		}
	} );

	/* Close nav when clicking on overlay */
	$( '.menu-overlay' ).click( function () {
		$html.removeClass( $navOpenClass );
	} );

	/* Inject Toggle */
	$( '.menu-item-has-children > a' ).after( '<div class="toggle"></div>' );

	/* Mobile Menu Accordion */
	$( '.toggle' ).on( 'click', function() {
		$( this ).nextAll( '.sub-menu' ).stop().slideToggle( 200 )
			.parent().toggleClass( 'active' );
	} );

	/* Desktop first item focus */
	$( '.site-header__nav-main>ul>.menu-item-has-children' ).hover( function() {
		$( this ).find( '.first-item' ).addClass( 'sub-menu--focus' );
	} );
	$( '.sub-menu' ).find( 'li' ).hover( function() {
		$( this ).parent().find( 'li' ).removeClass( 'sub-menu--focus' );
	} );

	/* Remove href */
	$( '.nohref > a' ).removeAttr( 'href' );

} )( jQuery );

